export const RECEIPT_DOWNLOAD_IMAGE_PADDING = 0;
